<template>
  <div class="forbidden-platform">
    <div class="forbidden-platform__top-bar">
      <Beacon class="forbidden-platform__beacon" />
    </div>
    <div class="forbidden-platform__container" v-if="platform">
      <div class="forbidden-platform__content">
        <TenderLogo class="forbidden-platform__tender-logo" width="145" />

        <h1 class="forbidden-platform__title">{{ $t('page.forbidden-platform.title') }}</h1>
        <p class="forbidden-platform__text">{{ platformName }}</p>
        <p>{{ $t('page.forbidden-platform.subtitle') }}</p>

        <div class="forbidden-platform__buttons">
          <BaseButton @click.native="contactUs" class="forbidden-platform__button">
            {{ $t('page.keywords.contact') }}
          </BaseButton>
          <BaseButton :to="tenders" class="forbidden-platform__button" has-icon-right is-outlined>
            {{ $t('not-found.btn2') }}
            <BaseIcon name="arrow-right" />
          </BaseButton>
        </div>
      </div>
      <ForbiddenPlatform class="forbidden-platform__image" height="403" />
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';
import Beacon from '@/components/Beacon';
import ForbiddenPlatform from '@/assets/images/unlock.svg';
import PlatformName from '@/mixins/platform-name-mixin';
import TenderLogo from '@/assets/images/aloha-logo.svg';

import { Beacon as BeaconPlugin } from '@/plugins/beacon';

export default {
  name: 'PageForbiddenPlatform',
  mixins: [PlatformName],
  components: {
    BaseButton,
    BaseIcon,
    Beacon,
    ForbiddenPlatform,
    TenderLogo,
  },
  props: {
    platform: String,
  },
  computed: {
    tenders() {
      return {
        name: 'tenders',
      };
    },
    platformName() {
      return this.getPlatformName(this.platform);
    },
  },
  methods: {
    contactUs() {
      this.$track.contactUs('beacon');
      BeaconPlugin.toggle();
      BeaconPlugin.navigate('ask');
    },
  },
};
</script>

<style lang="scss">
.forbidden-platform {
  align-items: center;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  min-height: var(--viewport-height);
  padding: 32px;
  width: 100%;

  &__top-bar {
    display: flex;
    max-width: 450px;
    width: 100%;
  }

  &__beacon {
    margin-left: auto;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    max-width: 450px;
    width: 100%;
  }

  &__tender-logo {
    color: $color-brand-500;
    margin-bottom: 40px;
  }

  &__title {
    margin: 0 0 24px;
  }

  &__text {
    font-size: 32px;
    margin-bottom: 16px;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
  }

  &__button {
    margin-top: 24px;
  }

  &__image {
    height: auto;
    margin-top: 40px;
    width: 200px;
  }
}

@media screen and (min-width: 784px) {
  .forbidden-platform {
    &__top-bar {
      max-width: initial;
    }

    &__container {
      flex-direction: row;
      max-width: 784px;
    }

    &__content {
      margin-right: 32px;
    }

    &__buttons {
      align-items: center;
      display: flex;
      flex-direction: row;
      margin-top: 40px;
    }

    &__button {
      margin-right: 32px;
      margin-top: 0;
    }

    &__image {
      margin-left: auto;
      margin-top: 0;
      width: auto;
    }
  }
}
</style>
